import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Bell, Check } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import api from '../utils/api';
import { toast } from 'sonner';
import { format } from 'date-fns';

const NotificationsPage = () => {
  const { i18n } = useTranslation();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await api.get('/notifications');
      setNotifications(response.data);
    } catch (error) {
      toast.error(
        i18n.language === 'ar' ? 'فشل تحميل الإشعارات' : 'Failed to load notifications'
      );
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await api.put(`/notifications/${notificationId}/read`);
      setNotifications(notifications.map(n => 
        n.id === notificationId ? { ...n, is_read: true } : n
      ));
    } catch (error) {
      toast.error(i18n.language === 'ar' ? 'حدث خطأ' : 'Error');
    }
  };

  return (
    <div className="min-h-screen" data-testid="notifications-page">
      <Navbar />
      <main className="pt-24 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">
            {i18n.language === 'ar' ? 'الإشعارات' : 'Notifications'}
          </h1>

          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : notifications.length === 0 ? (
            <Card>
              <CardContent className="flex flex-col items-center justify-center py-20">
                <Bell className="w-16 h-16 text-text-secondary mb-4" />
                <p className="text-text-secondary">
                  {i18n.language === 'ar' ? 'لا توجد إشعارات' : 'No notifications'}
                </p>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-4">
              {notifications.map((notification, index) => (
                <Card
                  key={notification.id}
                  className={`card ${!notification.is_read ? 'border-l-4 border-l-primary' : ''}`}
                  data-testid={`notification-${index}`}
                >
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="font-semibold text-lg mb-2">{notification.title}</h3>
                        <p className="text-text-secondary mb-3">{notification.message}</p>
                        <p className="text-sm text-text-secondary">
                          {format(new Date(notification.created_at), 'dd/MM/yyyy HH:mm')}
                        </p>
                      </div>
                      {!notification.is_read && (
                        <Button
                          onClick={() => markAsRead(notification.id)}
                          variant="ghost"
                          size="sm"
                          className="flex-shrink-0"
                          data-testid={`mark-read-btn-${index}`}
                        >
                          <Check className="w-4 h-4" />
                        </Button>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotificationsPage;
